import { render, staticRenderFns } from "./AssetMagnitude.vue?vue&type=template&id=6ff9b1fe"
import script from "./AssetMagnitude.vue?vue&type=script&lang=js"
export * from "./AssetMagnitude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports